import React, { useState } from 'react'
import axios from "axios";
import FormFooter from '../../general/FormFooter';
import { useHistory } from 'react-router-dom';

function CreateTable({ check }) {
    const [inputList, setInputList] = useState([{ fieldName: "", type: "STRING", allowNull: false }]);
    const [tablename, setTableName] = useState('');
    const [error, setError] = useState('');
    const history = useHistory();

    const styleObj = {
        cursor: 'pointer'
    }

    // handle input change
    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const list = [...inputList];
        list[index][name] = value;
        setInputList(list);
    };

    // handle click event of the Remove button
    const handleSave = async (e) => {
        e.preventDefault();
        let obj = {}
        inputList.forEach(item => {
            let name = item.fieldName;
            obj[name] = {
                type: `DataTypes.${item.type}`,
                allowNull: item.allowNull
            }
        });
        try {
            await axios.post(
                `${process.env.REACT_APP_BACKLINK}/api/private/create-table`,
                {
                    tablename: tablename,
                    tableInfo: obj
                },
                { withCredentials: true }
            );
            history.push('/show-tables')
        } catch (err) {
            setTimeout(() => {
                setError('')
            }, 5000)
            setError(err.response.msg)
        }
    }
    const handleRemoveClick = index => {
        const list = [...inputList];
        list.splice(index, 1);
        setInputList(list);
    };

    // handle click event of the Add button
    const handleAddClick = () => {
        setInputList([...inputList, { fieldName: "", type: "STRING", allowNull: false }]);
    };

    return (
        <>
            {console.log(check)}
            {!check ? <h1>You are not authorized</h1> :

                <form onSubmit={handleSave}>
                    {error && <div className="bg-danger msgDiv"><p>{error}</p></div>}
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Table Name:</label>
                                <input type="text" required className="form-control" value={tablename} onChange={e => setTableName(e.target.value)} />
                            </div>
                        </div>
                    </div>

                    {inputList.map((x, i) => {
                        return (
                            <div className="row" key={i}>
                                <div className="col-sm-6 mb-3">
                                    <label>Column Name : </label>
                                    <input
                                        className="form-control"
                                        required
                                        name="fieldName"
                                        onChange={e => handleInputChange(e, i)}
                                        value={x.fieldName}
                                    />
                                </div>
                                <div className="col-sm-6 mb-3">
                                    <label>Datatypes : </label>
                                    <select className="form-control form-select" name="type" value={x.type} onChange={e => handleInputChange(e, i)} >

                                        <option value="STRING">STRING</option>
                                        <option value="INTEGER">INTEGER</option>
                                        <option value="DATE">DATE</option>
                                    </select>
                                </div>
                                <div className="col-sm-6 mb-3">
                                    <label htmlFor="">Allow Null Value : </label>
                                    <select className="form-control form-select" name="allowNull" value={x.allowNull} onChange={e => handleInputChange(e, i)} >
                                        <option value="false">false</option>
                                        <option value="true">true</option>
                                    </select>
                                </div>
                                <div className="row mb-5">
                                    <div className="col-sm-2">
                                        {inputList.length !== 1 &&
                                            <svg style={styleObj} width="40" height="40" onClick={() => handleRemoveClick(i)} fill="currentColor" className="text-warning bi bi-dash-circle-fill" viewBox="0 0 16 16">
                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7z" />
                                            </svg>
                                            // <button className="btn btn-outline-danger btn-block" onClick={() => handleRemoveClick(i)}>Remove</button>
                                        }
                                    </div>
                                    <div className="col-sm-2">
                                        {inputList.length - 1 === i &&

                                            <svg style={styleObj} width="40" height="40" onClick={handleAddClick} fill="currentColor" className="text-info bi bi-plus-circle-fill" viewBox="0 0 16 16">
                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                                            </svg>
                                        }
                                    </div>
                                </div>
                            </div>
                        );
                    })}

                    <FormFooter button="Create Table" />
                </form>

            }
        </>
    );
}

export default CreateTable
